import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import { SplitButton } from '../../../common/SplitButton'
import UserWithTransactionrightReportTable from './userWithTransRightReportTable'
import { connect } from 'react-redux'
import { getLRPenaltyReportFilterData, getUserWithTransRightReportTableData, getOwnChildBranches } from '../../../../store/reports/reports_action'
import moment from 'moment'
import { focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { getCityList, updateAlertError } from '../../../../store/common/common_action'
import { PaymentTypesOptions, urls } from '../../../common/constants'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../../common/api'
import { ColumnUserwithTransRightReport, headerFilterColumnUserwithTransRightReport } from '../common/reportConstants'
const UserWithTransactionRightReport = (props) => {
    const { data: { common, reports }, getUserWithTransRightReportTableData, updateAlertError, getOwnChildBranches, getCityList } = props
    const { loginData, cityList, companySettings } = common
    const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD
    const { userWithTransRightReportData, ownChildBranches } = reports
    const [showReport, setShowReport] = useState(false)
    const [sourceBranchData, setSourceBranchData] = useState(ownChildBranches)
    const [sourceCity, setSourceCity] = useState([])
    const [sourceBranch, setSourceBranch] = useState([])
    const [selPaymentType, setSelPaymentType] = useState([])
    const [tableData, setTableData] = useState([])
    const [reportData, setReportData] = useState([]);
    const [sourceCityData, setSourceCityData] = useState([])
    const setAlert = useSetAtom(alertAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    const reportName = 'User With Transaction Right Report'
    useEffect(() => {
        // Add 'All' option to city list with id 0, only if the city list is not empty or already has the option
        if (cityList.length > 0) {
            const cityListWithAll = [{ CityID: 0, CityName: 'All' }, ...cityList];
            setSourceCityData(cityListWithAll)
            setSourceCity({ CityID: loginData?.intBranchCityID, CityName: loginData?.strCityName });  // Update the state with the new city list
        }

        if (ownChildBranches?.length > 0) {
            const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches];
            const filteredBranchList = branchListWithAll.filter(branch =>
                branch.CityID === (loginData?.intBranchCityID)
            );
            setSourceBranchData(filteredBranchList)
            //  setSourceBranchData(branchListWithAll);  // Update the state with the new branch list
            setSourceBranch({ BranchID: loginData?.intBranchID, BranchName: loginData?.strBranchName })
        }
        if (PaymentTypesOptions?.length > 0) {
            setSelPaymentType(PaymentTypesOptions[0])
        }

    }, [cityList, ownChildBranches, PaymentTypesOptions]);

    useEffect(() => {
        if (!isEmpty(loginData)) {
            getCityList(loginData)
            const branchData = {
                intUserID: 0,
                intCompanyID: loginData?.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
        }
    }, [loginData])
    useEffect(() => {
        if (userWithTransRightReportData?.length > 0) {
            let data = userWithTransRightReportData
            console.log(data, 'data')
            data = data.map((item, index) => ({
                ...item,
                sn: index + 1,

            }));
            setTableData(data)
            setReportData(data)
        } else {
            setTableData([])
            setReportData([])
        }
    }, [userWithTransRightReportData])
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    // const generateReport = () => {
    //     if (sourceCity == '' || sourceCity == ' ') {
    //         updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    //     } else if (sourceBranch == "" || sourceBranch == ' ') {
    //         updateAlertError({ show: true, msg: 'Select Branch', nextId: '' })
    //     }
    //     else if (selPaymentType == "" || selPaymentType == ' ') {
    //         updateAlertError({ show: true, msg: 'Select Payment Type', nextId: '' })
    //     } else {
    //         setShowReport(true)
    // const obj = {
    //     CityID: sourceCity?.CityID || 0,
    //     BranchID: sourceBranch?.BranchID || 0,
    //     PaymentTypeID: selPaymentType?.id || 0,
    //     CompanyID: loginData?.intCompanyID,
    // }
    //         getUserWithTransRightReportTableData(obj,UseToPayAsCOD)
    //     }
    // }
    const filterHeaderData = {
        company: loginData?.strCompanyName,
        city: sourceCity?.CityName,
        branch: sourceBranch?.BranchName,
        paymentType: selPaymentType?.Name,
        dataType: 'entry',
    }
    const generateReport = () => {
        if (sourceCity == '' || sourceCity == ' ') {
            setAlert({ show: true, msg: 'Select City', nextId: '' })
            return
        }
        setLoader(true)
        const obj = {
            CityID: sourceCity?.CityID || 0,
            BranchID: sourceBranch?.BranchID || 0,
            PaymentTypeID: selPaymentType?.id || 0,
            CompanyID: loginData?.intCompanyID,
        }
        GetRequest(urls.getUserWithTransRightReportTableData, obj)
            .then((res) => {
                if (res.status !== 'Success') {
                    throw new Error(res?.ErrMessage || 'Request Failed')
                }
                if (!Array.isArray(res.Table) || res.Table.length === 0) {
                    throw new Error('No Data Found')
                }
                //        "BookingRights": "Inactive",
                // "RefundRights": "Inactive",
                // "DeliveryRights": "Inactive",
                const updatedData = res?.Table.map((item, index) => ({
                    ...item,
                    SN: index + 1,
                    dataType: 'entry',
                    textColor: { BookingRights: item.BookingRights === 'Active' ? 'green' : "red", RefundRights: item.RefundRights === 'Active' ? 'green' : "red", DeliveryRights: item.DeliveryRights === 'Active' ? 'green' : "red", },
                    PaymentType:
                        UseToPayAsCOD === 1 && item.PaymentTypeId === 2
                            ? 'COD'
                            : item.PaymentTypeId === 7
                                ? 'COD(MANUAL)'
                                : item.PaymentTypeId === 9
                                    ? 'COD(DDDV)'
                                    : item.PaymentType,
                }))
                const reportPayload = {
                    reportName,
                    criteriaHeaders: headerFilterColumnUserwithTransRightReport,
                    criteriaData: [filterHeaderData],
                    tableData: updatedData,
                    mainHeader: ColumnUserwithTransRightReport,
                    isShowManageColumn: false,
                    manageColumnID: '',
                    hideHeader: false,
                    serialNokey: 'SN',
                }
                const rid = Date.now().toString()
                if (!window.generatedReports) {
                    window.generatedReports = {}
                }
                window.generatedReports[rid] = reportPayload
                window.open(`/view-report?rid=${rid}`, '_blank')
            })
            .catch((err) => {
                setAlert({ show: true, msg: err.message, nextId: '' })
            })
            .finally(() => setLoader(false))
    }

    const selectedSourceCity = (obj) => {
        setShowReport(false)
        setSourceCity(obj)
        if (obj?.CityID === 0) {
            const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches];
            setSourceBranchData(branchListWithAll);
            setSourceBranch(branchListWithAll[0])
        } else {
            const filteredBranches = ownChildBranches?.filter((val) => val.CityID === obj?.CityID);
            const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...filteredBranches];
            setSourceBranchData(branchListWithAll);
            setSourceBranch(branchListWithAll[0])

        }
    }
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                <ReportHeading reportName={reportName} />
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            label={"Select Company"}
                            defaultvalue={loginData.strCompanyName}
                            disabled={true}
                            width="300px"
                        />{' '}
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary" >
                            GO
                        </Button>
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={`Select City`}
                            id={'paymentType'}
                            data={sourceCityData || []}
                            defaultvalue={sourceCity?.CityName || sourceCity}
                            dataKey={`CityName`}
                            idKey={`CityID`}
                            onSelect={(obj) => { selectedSourceCity(obj) }}
                            width="100%"
                            nextId={'selectedBranch'}
                            prevId={'goButtonDate'}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            id={'selectedBranch'}
                            label={'Select Branch'}
                            // data={roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 ? ownChildBranches.filter((val) => val.SourceBranchID == loginData?.intBranchCityID) : ownChildBranches || []}
                            data={sourceBranchData || []}
                            searchPlaceholder={`Search By Branch`}
                            defaultvalue={sourceBranch?.BranchName || sourceBranch}
                            dataKey={`BranchName`}
                            idKey={`BranchID`}
                            onSelect={(val) => { setShowReport(false); setSourceBranch(val) }}
                            onReset={() => setSourceBranch('')}
                            nextId={'generateButton'}
                            prevId={'paymentType'}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={`Payment Type`}
                            id={'paymentType'}
                            // data={PaymentTypesOptions}
                            data={(PaymentTypesOptions || []).map((item) => {
                                if (UseToPayAsCOD === 1) {
                                    if (item.id === 2) {
                                        return { ...item, Name: 'COD' };
                                    }
                                    if (item.id === 7) {
                                        return { ...item, Name: 'COD Manual' };
                                    }
                                    if (item.id === 9) {
                                        return { ...item, Name: 'COD DDDV' };
                                    }
                                    if (item.id === 4) {
                                        return null;
                                    }
                                }
                                return item;
                            }).filter(Boolean)
                            }
                            defaultvalue={selPaymentType?.Name || selPaymentType}
                            searchPlaceholder={`Search By Payment`}
                            HasAllSelect={true}
                            dataKey={`Name`}
                            idKey={`id`}
                            onSelect={(val) => {
                                setSelPaymentType(val)
                            }} width="100%"
                            nextId={'selectedBranch'}
                            prevId={'goButtonDate'}
                        />
                    </Item>
                    <Item sx={sx.itemsx}
                        onKeyDown={(e) => { navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'selectedBranch', () => generateReport()) }}
                    >
                        <SplitButton
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            // hideToggle={false}
                            id1={'generateButton'}
                            onClick1={generateReport}
                        // onClick2={handleClick2}
                        />
                    </Item>
                </Box>
            </Item>
            {
                showReport ? <UserWithTransactionrightReportTable tableData={tableData} loginData={loginData} sourceCity={sourceCity} sourceBranch={sourceBranch} selPaymentType={selPaymentType} setTableData={setTableData} reportData={reportData} /> : ''
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getLRPenaltyReportFilterData, getUserWithTransRightReportTableData, updateAlertError, getOwnChildBranches, getCityList }
export default connect(mapStateToProps, mapDispatchToProps)(UserWithTransactionRightReport)